import { CATEGORY_META } from "../../lib/constants";
import type { Category } from "../../lib/api";
import { cn } from "../../lib/cn";

export function CategoryBadge({
  category,
  className,
}: {
  category: Category;
  className?: string;
}) {
  const meta = CATEGORY_META[category];
  if (!meta) return null;
  return (
    <span
      className={cn(
        "badge text-slate-200 bg-white/5 border-white/10",
        className,
      )}
    >
      {meta.label}
    </span>
  );
}
